export class ProductViewModel {
	readonly id: string;
	readonly label: string;

	isSelected: boolean = false;
	isValid: boolean = true;

	constructor (id: string, label: string) {
		this.id = id;
		this.label = label;
	}
}
